import { MatchStatus } from "service";
import { SIDE } from "_constants";

export const TENNIS_VIEW_W = 400;
export const TENNIS_VIEW_H = 240;

export const TENNIS_FALLBACK_POSITIONS: Record<SIDE, { x: number; y: number }> =
  {
    [SIDE.NO_SIDE]: { x: 0.5, y: 0.5 },
    [SIDE.HOME]: { x: 0.11, y: 0.52 },
    [SIDE.AWAY]: { x: 0.89, y: 0.48 },
  };

const parseSideFromCode = (value: unknown): SIDE | undefined => {
  if (value == null) return undefined;

  const str = typeof value === "number" ? value.toString() : String(value);
  if (!str || str.length === 0) return undefined;

  const key = str.trim().charAt(0);
  if (key === "1") return SIDE.HOME;
  if (key === "2") return SIDE.AWAY;
  return undefined;
};

export const normalizeTennisSide = (rawSide: unknown): SIDE => {
  if (
    rawSide === SIDE.HOME ||
    rawSide === SIDE.AWAY ||
    rawSide === SIDE.NO_SIDE
  ) {
    return rawSide as SIDE;
  }

  if (typeof rawSide === "number") {
    if (rawSide === SIDE.HOME) return SIDE.HOME;
    if (rawSide === SIDE.AWAY) return SIDE.AWAY;
    return SIDE.NO_SIDE;
  }

  if (typeof rawSide === "string") {
    const trimmed = rawSide.trim().toLowerCase();
    if (trimmed === "home" || trimmed === "h") return SIDE.HOME;
    if (trimmed === "away" || trimmed === "a") return SIDE.AWAY;

    const parsed = Number(trimmed);
    if (!Number.isNaN(parsed)) {
      if (parsed === SIDE.HOME) return SIDE.HOME;
      if (parsed === SIDE.AWAY) return SIDE.AWAY;
    }
  }

  return SIDE.NO_SIDE;
};

export const resolveTennisPosition = (
  status: MatchStatus
): { x: number; y: number; side: SIDE } => {
  const raw = status as unknown as {
    x?: number;
    y?: number;
    side?: unknown;
    sc?: unknown;
    nsc?: unknown;
  };

  const explicitSide = normalizeTennisSide(raw?.side);
  const derivedSide =
    explicitSide !== SIDE.NO_SIDE
      ? explicitSide
      : parseSideFromCode(raw?.sc) ??
        parseSideFromCode(raw?.nsc) ??
        SIDE.NO_SIDE;
  const resolvedSide = derivedSide;
  const fallback = TENNIS_FALLBACK_POSITIONS[resolvedSide];

  const hasX = typeof raw?.x === "number";
  const hasY = typeof raw?.y === "number";

  return {
    x: hasX ? (raw?.x as number) : fallback.x,
    y: hasY ? (raw?.y as number) : fallback.y,
    side: resolvedSide,
  };
};
